import httpClient from '../../../api/httpClient';
import API_CONFIG from '../../../config/api.config';

const ENDPOINT = API_CONFIG.ENDPOINTS.EMPLOYEES || '/api/employees';

export interface Employee {
  id: string;
  firstName: string;
  lastName: string;
  employeeType: string;
  employee_Type?: string; // For API response compatibility
  email?: string;
  phoneNumber?: string;
  departmentId?: string;
  isActive: boolean;
  specialization?: string;
}

export const employeeApi = {
  getDoctors: async (): Promise<Employee[]> => {
    try {
      console.log('Fetching doctors from:', `${ENDPOINT}`);
      const params = new URLSearchParams();
      params.append('employee_Type', 'DOCTOR');
      params.append('isActive', 'true');
      
      console.log('Request params:', Object.fromEntries(params));
      
      const response = await httpClient.get<Employee[]>(`${ENDPOINT}?${params.toString()}`);
      
      console.log('Raw API response:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data
      });
      
      if (!Array.isArray(response.data)) {
        console.error('Unexpected response format:', response.data);
        return [];
      }

      // Log the first few items to check their structure
      console.log('First 3 items:', response.data.slice(0, 3).map(d => ({
        id: d.id,
        firstName: d.firstName,
        lastName: d.lastName,
        employeeType: d.employeeType,
        employee_Type: d.employee_Type,
        isActive: d.isActive
      })));
      
      // Client-side filtering as fallback
      const doctors = response.data.filter(emp => {
        const type = (emp.employee_Type || emp.employeeType || '').toUpperCase();
        return type === 'DOCTOR' && emp.isActive !== false;
      });
      
      console.log(`Filtered to ${doctors.length} active doctors`);
      return doctors;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message;
      const status = error.response?.status;
      
      console.error('Error in getDoctors:', {
        message: errorMessage,
        status: status,
        error: error
      });
      
      throw new Error(`Failed to fetch doctors: ${errorMessage}`);
    }
  },

  getDoctorById: async (id: string): Promise<Employee> => {
    try {
      const response = await httpClient.get<Employee>(`${ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching doctor ${id}:`, error);
      throw new Error('Failed to fetch doctor details');
    }
  }
};
